import React from 'react';
import {
  Styled,
} from '@unthinkable/react-core-components';

export const FileInputCell = Styled.input`
display: none`;
